/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  EquipmentGradesFiltersParams,
  EquipmentItemTypesFiltersParams,
  EquipmentSizesFiltersParams,
  FilterOptionsList,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Equipment Grade Filters
 */
export const equipmentGradesFilters = (
    params?: MaybeRefOrGetter<EquipmentGradesFiltersParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<FilterOptionsList>(
      {url: `/filters/equipment/grades`, method: 'GET',
        params, signal
    },
      );
    }




export const getEquipmentGradesFiltersQueryKey = (params?: MaybeRefOrGetter<EquipmentGradesFiltersParams>,) => {
    return [
    'filters','equipment','grades', ...(params ? [params] : [])
    ] as const;
    }


export const getEquipmentGradesFiltersQueryOptions = <TData = Awaited<ReturnType<typeof equipmentGradesFilters>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<EquipmentGradesFiltersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentGradesFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentGradesFiltersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipmentGradesFilters>>> = ({ signal }) => equipmentGradesFilters(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipmentGradesFilters>>, TError, TData>
}

export type EquipmentGradesFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof equipmentGradesFilters>>>
export type EquipmentGradesFiltersQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Equipment Grade Filters
 */

export function useEquipmentGradesFilters<TData = Awaited<ReturnType<typeof equipmentGradesFilters>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<EquipmentGradesFiltersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentGradesFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentGradesFiltersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Equipment Item Type Filters
 */
export const equipmentItemTypesFilters = (
    params?: MaybeRefOrGetter<EquipmentItemTypesFiltersParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<FilterOptionsList>(
      {url: `/filters/equipment/item-types`, method: 'GET',
        params, signal
    },
      );
    }




export const getEquipmentItemTypesFiltersQueryKey = (params?: MaybeRefOrGetter<EquipmentItemTypesFiltersParams>,) => {
    return [
    'filters','equipment','item-types', ...(params ? [params] : [])
    ] as const;
    }


export const getEquipmentItemTypesFiltersQueryOptions = <TData = Awaited<ReturnType<typeof equipmentItemTypesFilters>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<EquipmentItemTypesFiltersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentItemTypesFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentItemTypesFiltersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipmentItemTypesFilters>>> = ({ signal }) => equipmentItemTypesFilters(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipmentItemTypesFilters>>, TError, TData>
}

export type EquipmentItemTypesFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof equipmentItemTypesFilters>>>
export type EquipmentItemTypesFiltersQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Equipment Item Type Filters
 */

export function useEquipmentItemTypesFilters<TData = Awaited<ReturnType<typeof equipmentItemTypesFilters>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<EquipmentItemTypesFiltersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentItemTypesFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentItemTypesFiltersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Equipment Size Filters
 */
export const equipmentSizesFilters = (
    params?: MaybeRefOrGetter<EquipmentSizesFiltersParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<FilterOptionsList>(
      {url: `/filters/equipment/sizes`, method: 'GET',
        params, signal
    },
      );
    }




export const getEquipmentSizesFiltersQueryKey = (params?: MaybeRefOrGetter<EquipmentSizesFiltersParams>,) => {
    return [
    'filters','equipment','sizes', ...(params ? [params] : [])
    ] as const;
    }


export const getEquipmentSizesFiltersQueryOptions = <TData = Awaited<ReturnType<typeof equipmentSizesFilters>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<EquipmentSizesFiltersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentSizesFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentSizesFiltersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipmentSizesFilters>>> = ({ signal }) => equipmentSizesFilters(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipmentSizesFilters>>, TError, TData>
}

export type EquipmentSizesFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof equipmentSizesFilters>>>
export type EquipmentSizesFiltersQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Equipment Size Filters
 */

export function useEquipmentSizesFilters<TData = Awaited<ReturnType<typeof equipmentSizesFilters>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<EquipmentSizesFiltersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentSizesFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentSizesFiltersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Equipment Slot Filters
 */
export const equipmentSlotsFilters = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/filters/equipment/slots`, method: 'GET', signal
    },
      );
    }




export const getEquipmentSlotsFiltersQueryKey = () => {
    return [
    'filters','equipment','slots'
    ] as const;
    }


export const getEquipmentSlotsFiltersQueryOptions = <TData = Awaited<ReturnType<typeof equipmentSlotsFilters>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentSlotsFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentSlotsFiltersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipmentSlotsFilters>>> = ({ signal }) => equipmentSlotsFilters(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipmentSlotsFilters>>, TError, TData>
}

export type EquipmentSlotsFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof equipmentSlotsFilters>>>
export type EquipmentSlotsFiltersQueryError = ErrorType<unknown>


/**
 * @summary Equipment Slot Filters
 */

export function useEquipmentSlotsFilters<TData = Awaited<ReturnType<typeof equipmentSlotsFilters>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentSlotsFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentSlotsFiltersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Equipment Sub Type Filters
 */
export const equipmentSubTypesFilters = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/filters/equipment/sub-types`, method: 'GET', signal
    },
      );
    }




export const getEquipmentSubTypesFiltersQueryKey = () => {
    return [
    'filters','equipment','sub-types'
    ] as const;
    }


export const getEquipmentSubTypesFiltersQueryOptions = <TData = Awaited<ReturnType<typeof equipmentSubTypesFilters>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentSubTypesFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentSubTypesFiltersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipmentSubTypesFilters>>> = ({ signal }) => equipmentSubTypesFilters(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipmentSubTypesFilters>>, TError, TData>
}

export type EquipmentSubTypesFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof equipmentSubTypesFilters>>>
export type EquipmentSubTypesFiltersQueryError = ErrorType<unknown>


/**
 * @summary Equipment Sub Type Filters
 */

export function useEquipmentSubTypesFilters<TData = Awaited<ReturnType<typeof equipmentSubTypesFilters>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentSubTypesFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentSubTypesFiltersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Equipment Type Filters
 */
export const equipmentTypesFilters = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/filters/equipment/types`, method: 'GET', signal
    },
      );
    }




export const getEquipmentTypesFiltersQueryKey = () => {
    return [
    'filters','equipment','types'
    ] as const;
    }


export const getEquipmentTypesFiltersQueryOptions = <TData = Awaited<ReturnType<typeof equipmentTypesFilters>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentTypesFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentTypesFiltersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipmentTypesFilters>>> = ({ signal }) => equipmentTypesFilters(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipmentTypesFilters>>, TError, TData>
}

export type EquipmentTypesFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof equipmentTypesFilters>>>
export type EquipmentTypesFiltersQueryError = ErrorType<unknown>


/**
 * @summary Equipment Type Filters
 */

export function useEquipmentTypesFilters<TData = Awaited<ReturnType<typeof equipmentTypesFilters>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentTypesFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentTypesFiltersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Equipment Weapon Class Filters
 */
export const equipmentWeaponClassesFilters = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/filters/equipment/weapon-classes`, method: 'GET', signal
    },
      );
    }




export const getEquipmentWeaponClassesFiltersQueryKey = () => {
    return [
    'filters','equipment','weapon-classes'
    ] as const;
    }


export const getEquipmentWeaponClassesFiltersQueryOptions = <TData = Awaited<ReturnType<typeof equipmentWeaponClassesFilters>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentWeaponClassesFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentWeaponClassesFiltersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipmentWeaponClassesFilters>>> = ({ signal }) => equipmentWeaponClassesFilters(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipmentWeaponClassesFilters>>, TError, TData>
}

export type EquipmentWeaponClassesFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof equipmentWeaponClassesFilters>>>
export type EquipmentWeaponClassesFiltersQueryError = ErrorType<unknown>


/**
 * @summary Equipment Weapon Class Filters
 */

export function useEquipmentWeaponClassesFilters<TData = Awaited<ReturnType<typeof equipmentWeaponClassesFilters>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentWeaponClassesFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentWeaponClassesFiltersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






